<template>
  <BgImageLayout>
    <EmailModal ref="modal" />

    <Grid gtr="auto 1fr" class="full-height shadow3 list-view-emails relative-position">
      <CardHeader :ag-grid="agGrid" @export="$refs.emailsTable.exportToExcel()" />

      <EmailsTable ref="emailsTable" @ag-grid="agGrid = $event" @see-subject="openEmailModal" />
    </Grid>
  </BgImageLayout>
</template>

<script>
// Vuex
import VuexModule from './vuex-module'
// Components
import EmailModal from '@/reusable/EmailModal'
import CardHeader from './components/CardHeader'
import EmailsTable from './components/emails-table/EmailsTable.vue'

export default {
  components: {
    EmailModal,
    EmailsTable,
    CardHeader
  },

  data: () => ({
    agGrid: null
  }),

  beforeCreate() {
    this.$store.registerModule('lv-emails', VuexModule)
  },

  destroyed() {
    this.$store.unregisterModule('lv-emails')
  },

  methods: {
    openEmailModal(emailId) {
      this.$refs.modal.show(emailId)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-emails {
  border-radius: 2px;
  overflow: hidden;
  isolation: isolate;
}
</style>
